// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nurturer-auth {
  --bg: #F4F2EB;
  --surface: #FFFFFF;
  --surface-alt: #FAF8F2;
  --teal: #23C2C4;
  --teal-deep: #0C8587;
  --teal-deeper: #0A6F71;
  --primary: #0C8587;
  --primary-soft: #DEF3F3;
  --accent: #DD9F3C;
  --cream: #F3ECC4;
  --ink: #1B241F;
  --ink-70: rgba(27, 36, 31, 0.72);
  --muted: #6C766F;
  --faint: #9AA29B;
  --border: rgba(28, 40, 33, 0.10);
  --border-strong: rgba(28, 40, 33, 0.16);
  --on-teal: #FFFFFF;
  --on-teal-70: rgba(255, 255, 255, 0.80);
  --shadow-lg: 0 40px 90px -40px rgba(20, 30, 24, 0.45), 0 6px 16px rgba(20, 30, 24, 0.06);
  --sans: 'DM Sans', system-ui, -apple-system, sans-serif;
  --serif: 'Newsreader', Georgia, serif;
  --mono: 'JetBrains Mono', ui-monospace, monospace;

  min-height: 100vh;
  color: var(--ink);
  font-family: var(--sans);
  -webkit-font-smoothing: antialiased;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 24px;
  background:
    radial-gradient(900px 500px at 88% -10%, rgba(35, 194, 196, 0.10), transparent 60%),
    radial-gradient(760px 520px at 6% 108%, rgba(221, 159, 60, 0.10), transparent 60%),
    var(--bg);
}

.nurturer-auth *,
.nurturer-auth *::before,
.nurturer-auth *::after {
  box-sizing: border-box;
}

.nurturer-auth a {
  color: inherit;
  text-decoration: none;
}

.nurturer-auth .auth {
  width: 100%;
  max-width: 960px;
  background: var(--surface);
  border-radius: 24px;
  box-shadow: var(--shadow-lg);
  overflow: hidden;
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.nurturer-auth .auth-form {
  padding: 48px 52px;
  display: flex;
  flex-direction: column;
}

.nurturer-auth .brand {
  display: flex;
  align-items: center;
  gap: 11px;
  margin-bottom: 38px;
}

.nurturer-auth .brand .mark {
  width: 38px;
  height: 38px;
}

.nurturer-auth .brand .name {
  font-weight: 700;
  font-size: 19px;
  letter-spacing: 0.4px;
}

.nurturer-auth .auth-head h1 {
  font-family: var(--sans);
  font-weight: 700;
  font-size: 28px;
  letter-spacing: -0.6px;
  margin: 0;
}

.nurturer-auth .auth-head h1 em {
  font-family: var(--serif);
  font-style: italic;
  font-weight: 400;
  color: var(--primary);
}

.nurturer-auth .auth-head p {
  font-size: 14.5px;
  color: var(--muted);
  margin: 8px 0 0;
  line-height: 1.5;
}

.nurturer-auth form {
  margin-top: 28px;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.nurturer-auth .row2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}

.nurturer-auth .field {
  display: flex;
  flex-direction: column;
}

.nurturer-auth .field label {
  font-size: 12.5px;
  font-weight: 600;
  color: var(--ink-70);
  margin-bottom: 7px;
}

.nurturer-auth .field-error {
  font-size: 12px;
  color: #b00020;
  margin-top: 5px;
}

.nurturer-auth .ctrl {
  position: relative;
  display: flex;
  align-items: center;
}

.nurturer-auth .ctrl .lead {
  position: absolute;
  left: 14px;
  display: flex;
  color: var(--faint);
  pointer-events: none;
}

.nurturer-auth .inp {
  width: 100%;
  font-family: var(--sans);
  font-size: 14.5px;
  color: var(--ink);
  background: var(--surface-alt);
  border: 1px solid var(--border);
  border-radius: 11px;
  padding: 12px 14px;
  outline: none;
  transition: border 0.15s, box-shadow 0.15s;
}

.nurturer-auth .inp.has-lead {
  padding-left: 42px;
}

.nurturer-auth .inp.has-trail {
  padding-right: 44px;
}

.nurturer-auth .inp::placeholder {
  color: var(--faint);
}

.nurturer-auth .inp:focus {
  border-color: var(--primary);
  box-shadow: 0 0 0 3px var(--primary-soft);
}

.nurturer-auth .inp.inp-error {
  border-color: #b00020;
}

.nurturer-auth .toggle {
  position: absolute;
  right: 8px;
  width: 30px;
  height: 30px;
  border: none;
  background: transparent;
  color: var(--faint);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 8px;
}

.nurturer-auth .toggle:hover {
  color: var(--muted);
  background: rgba(28, 40, 33, 0.05);
}

.nurturer-auth .row-between {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: -2px;
}

.nurturer-auth .remember {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: var(--ink-70);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.nurturer-auth .remember input {
  width: 15px;
  height: 15px;
  accent-color: var(--primary);
}

.nurturer-auth .link {
  color: var(--primary);
  font-weight: 600;
  font-size: 13.5px;
}

.nurturer-auth .link:hover {
  color: var(--teal-deeper);
  text-decoration: underline;
}

.nurturer-auth .btn-primary {
  margin-top: 6px;
  width: 100%;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  background: var(--primary);
  color: #fff;
  font-family: var(--sans);
  font-weight: 600;
  font-size: 15px;
  padding: 14px 20px;
  box-shadow: 0 12px 28px -14px rgba(12, 133, 135, 0.85);
  transition: background 0.15s, transform 0.08s, opacity 0.15s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
}

.nurturer-auth .btn-primary:hover:not(:disabled) {
  background: var(--teal-deeper);
}

.nurturer-auth .btn-primary:active:not(:disabled) {
  transform: translateY(1px);
}

.nurturer-auth .btn-primary:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.nurturer-auth .alt {
  margin-top: auto;
  padding-top: 28px;
  font-size: 14px;
  color: var(--muted);
}

.nurturer-auth .divider {
  display: flex;
  align-items: center;
  gap: 14px;
  margin: 22px 0 4px;
  color: var(--faint);
  font-size: 12px;
}

.nurturer-auth .divider::before,
.nurturer-auth .divider::after {
  content: '';
  height: 1px;
  background: var(--border);
  flex: 1;
}

.nurturer-auth .auth-alert {
  margin-top: 20px;
  padding: 12px 14px;
  border-radius: 11px;
  font-size: 13.5px;
  line-height: 1.45;
}

.nurturer-auth .auth-alert-error {
  background: #fdecea;
  color: #8a1c1c;
  border: 1px solid rgba(176, 0, 32, 0.15);
}

.nurturer-auth .auth-alert-success {
  background: var(--primary-soft);
  color: var(--teal-deeper);
  border: 1px solid rgba(12, 133, 135, 0.15);
}

.nurturer-auth .auth-aside {
  position: relative;
  overflow: hidden;
  color: var(--on-teal);
  padding: 56px 48px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background:
    radial-gradient(560px 360px at 90% -10%, rgba(243, 236, 196, 0.30), transparent 60%),
    linear-gradient(150deg, #1FB3B5 0%, #23C2C4 44%, #0C8587 100%);
}

.nurturer-auth .auth-aside .blob {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.08);
}

.nurturer-auth .auth-aside .b1 {
  width: 240px;
  height: 240px;
  top: -70px;
  right: -70px;
}

.nurturer-auth .auth-aside .b2 {
  width: 160px;
  height: 160px;
  bottom: -50px;
  left: -40px;
  background: rgba(243, 236, 196, 0.12);
}

.nurturer-auth .aside-eyebrow {
  font-family: var(--mono);
  font-size: 11px;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: var(--cream);
  position: relative;
}

.nurturer-auth .aside-title {
  font-family: var(--serif);
  font-weight: 500;
  font-size: 42px;
  line-height: 1.06;
  letter-spacing: -0.5px;
  margin: 16px 0 0;
  position: relative;
}

.nurturer-auth .aside-sub {
  font-size: 15px;
  line-height: 1.6;
  color: var(--on-teal-70);
  margin: 18px 0 0;
  max-width: 320px;
  position: relative;
}

.nurturer-auth .benefits {
  list-style: none;
  padding: 0;
  margin: 30px 0 0;
  display: flex;
  flex-direction: column;
  gap: 15px;
  position: relative;
}

.nurturer-auth .benefits li {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  font-size: 15px;
  font-weight: 500;
}

.nurturer-auth .benefits .tick {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.16);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--cream);
  margin-top: 1px;
}

.nurturer-auth .aside-foot {
  position: relative;
  margin-top: 34px;
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 13px;
  color: var(--on-teal-70);
}

.nurturer-auth .aside-foot .avatars {
  display: flex;
}

.nurturer-auth .aside-foot .avatars span {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 2px solid #1FB3B5;
  margin-left: -8px;
  background: var(--cream);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  color: var(--ink);
}

.nurturer-auth .aside-foot .avatars span:first-child {
  margin-left: 0;
}

@media (max-width: 800px) {
  .nurturer-auth .auth {
    grid-template-columns: 1fr;
    max-width: 460px;
  }

  .nurturer-auth .auth-aside {
    display: none;
  }

  .nurturer-auth .auth-form {
    padding: 40px 32px;
  }

  .nurturer-auth .row2 {
    grid-template-columns: 1fr;
  }
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
